import React from "react";
import "./ContactCards.css";
import PhoneIcon from "@mui/icons-material/Phone";
import ChatIcon from "@mui/icons-material/Chat";
import EmailIcon from "@mui/icons-material/Email";

const ContactCards = () => {
  return (
    <div className="contact">
      <div className="contact__cards">
        {/* Phone Card */}
        <div className="contact__card">
          <div className="contact__icon">
            <PhoneIcon fontSize="large" />
          </div>
          <h3 className="contact__heading">Phone Call</h3>
          <p className="contact__text">You can contact us on +123 456 7890</p>
        </div>

        {/* Live Chat Card */}
        <div className="contact__card">
          <div className="contact__icon">
            <ChatIcon fontSize="large" />
          </div>
          <h3 className="contact__heading">Live Chat</h3>
          <p className="contact__text">
            Available on our platform from 9:00 AM to 5:00 PM
          </p>
        </div>

        {/* Email Card */}
        <div className="contact__card">
          <div className="contact__icon">
            <EmailIcon fontSize="large" />
          </div>
          <h3 className="contact__heading">Email</h3>
          <p className="contact__text">
            support@pamundo.com or mailto:support@pamundo.com
          </p>
        </div>
      </div>
    </div>
  );
};

export default ContactCards;
